import { render, staticRenderFns } from "./Proforma-Create.vue?vue&type=template&id=188a7d6e"
import script from "./Proforma-Create.vue?vue&type=script&lang=js"
export * from "./Proforma-Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports